import { useState, useEffect } from 'react';
import { Permission } from '../../types/permissions/permission';
import { rolePermissionService } from '../../services';
import toast from 'react-hot-toast';

export const useRolePermissions = (roleId: number | null) => {
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadRolePermissions = async (id: number) => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await rolePermissionService.getRolePermissions(id);
      if (response.success && response.permissions) {
        setPermissions(response.permissions);
      }
    } catch (err) {
      console.error('Error cargando permisos del rol:', err);
      setError('Error al cargar los permisos del rol');
/*       toast.error('Error al cargar los permisos del rol'); */
      setLoading(false);

    } finally {
      setLoading(false);
    }
  };

  const updateRolePermissions = async (permissionIds: number[]) => {
    if (!roleId) return false;

    try {
      const response = await rolePermissionService.updateRolePermissions(roleId, permissionIds);
      if (response.success) {
        toast.success(response.message || 'Permisos actualizados exitosamente');
        await loadRolePermissions(roleId); // Recargar permisos
        return true;
      }
      return false;
    } catch (err) {
      console.error('Error actualizando permisos:', err);
      toast.error('Error al actualizar los permisos');
      return false;
    }
  };

  useEffect(() => {
    if (roleId) {
      loadRolePermissions(roleId);
    } else {
      setPermissions([]);
    }
  }, [roleId]);

  return {
    permissions,
    loading,
    error,
    loadRolePermissions,
    updateRolePermissions
  };
};
